<template>
  <SBtn
    color="primary"
    text
    data-testid="toggle-events-btn"
    :aria-label="$t('header.module.updates')"
    :aria-expanded="`${expanded}`"
    @click="emits('toggle')"
  >
    <VIcon aria-hidden="true">
      {{ icons.mdiBullhornVariantOutline }}
    </VIcon>
  </SBtn>
</template>

<script setup lang="ts">
import { mdiBullhornVariantOutline } from '@mdi/js'

// The demonstrator's mobile Events toggle in the header nav icon row. Ported
// from nuxt2; the label and aria-expanded are added, since an icon-only button
// otherwise has no accessible name. AB#63680
withDefaults(defineProps<{ expanded?: boolean }>(), { expanded: false })

const emits = defineEmits<{
  (e: 'toggle'): void
}>()

const icons = { mdiBullhornVariantOutline }
</script>
